// Before/After gallery projects.
// To add or replace a project: drop new images in /public/assets/gallery/
// (provide both .webp and .jpg with the same name) and update the entries below.
// `tags` control which filters the project appears under.
// Available filters: Kitchens, Bathrooms, Move-Outs, Detailed Cleaning,
// Windows/Blinds, Property Turnovers, Junk Removal

export const PROJECTS = [
  {
    id: "kitchen-sink",
    title: "Kitchen Sink Deep Clean",
    label: "Kitchen Cleaning",
    tags: ["Kitchens", "Detailed Cleaning"],
    before: "/assets/gallery/before1",
    after: "/assets/gallery/after1",
    description:
      "A double stainless kitchen sink and fixtures returned to a bright, spotless finish.",
    aspect: "3 / 4",
  },
  {
    id: "window-track",
    title: "Window Sill & Track Detail",
    label: "Move-Out Cleaning",
    tags: ["Windows/Blinds", "Move-Outs", "Detailed Cleaning"],
    before: "/assets/gallery/before2",
    after: "/assets/gallery/after2",
    description:
      "Built-up grime cleared from window sills and tracks during a move-out detail.",
    aspect: "3 / 4",
  },
  {
    id: "tub-shower",
    title: "Tub & Shower Refresh",
    label: "Bathroom Cleaning",
    tags: ["Bathrooms", "Detailed Cleaning"],
    before: "/assets/gallery/before3",
    after: "/assets/gallery/after3",
    description: "A tub and surround wiped down to a clean, refreshed shine.",
    aspect: "3 / 4",
  },
  {
    id: "window-blinds",
    title: "Window Blinds Restored",
    label: "Move-Out Cleaning",
    tags: ["Windows/Blinds", "Move-Outs", "Detailed Cleaning"],
    before: "/assets/gallery/before4",
    after: "/assets/gallery/after4",
    description:
      "Marked and dusty blinds cleaned slat by slat for a like-new look.",
    aspect: "3 / 4",
  },
  {
    id: "bathroom-vanity",
    title: "Bathroom Vanity Refresh",
    label: "Bathroom Cleaning",
    tags: ["Bathrooms", "Detailed Cleaning"],
    before: "/assets/gallery/before5",
    after: "/assets/gallery/after5",
    description: "A bathroom vanity and sink cleaned to a bright, polished finish.",
    aspect: "3 / 4",
  },
  {
    id: "apartment-cleanout",
    title: "Apartment Cleanout",
    label: "Junk Removal",
    tags: ["Junk Removal", "Property Turnovers", "Move-Outs"],
    before: "/assets/gallery/before6",
    after: "/assets/gallery/after6",
    description:
      "Left-behind belongings, bagged trash and debris cleared out for a move-ready unit.",
    aspect: "3 / 4",
  },
  {
    id: "room-cleanout",
    title: "Room Cleanout & Turnover",
    label: "Junk Removal",
    tags: ["Junk Removal", "Property Turnovers", "Move-Outs"],
    before: "/assets/gallery/before7",
    after: "/assets/gallery/after7",
    description:
      "A cluttered room emptied of debris and unwanted items, ready for its next resident.",
    aspect: "3 / 4",
  },
  {
    id: "bedroom-cleanout",
    title: "Bedroom Cleanout",
    label: "Junk Removal",
    tags: ["Junk Removal", "Move-Outs"],
    before: "/assets/gallery/before8",
    after: "/assets/gallery/after8",
    description:
      "Mattress, furniture and scattered debris removed to fully clear the bedroom.",
    aspect: "3 / 4",
  },
];
